export function isValidButton({ children }: TContent): boolean {
  return !!children.length;
}
